module.exports = __webpack_public_path__ + "static/media/BG.a386c530.jpg";